// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import './assets/css/index.scss';
import './assets/js/elementJs.js';
import './icons';
import {autoRefresh} from './assets/js/autoCheckUpdate';
import loading from './components/widget/loading';
import commonView from './components/common/install';
import commonTooltip from './components/common/com-tooltip/directive';

import * as utils from './assets/js/utils';
import * as constant from './assets/js/constant';
import * as validConst from './assets/js/validate';
import * as api from './assets/js/api';
import AppCache from './assets/js/appCache';
// 全局指令
import './assets/js/directive';
import domLoading from '@/components/common/dom-loading';
import BatchUploadDialog from './pages/case-handling/components/batch-upload/batch-upload-dialog-loader';
import ComBatchUploadDialog from '@/pages/case-import/meterial-upload/materila-batch-upload-loader.js';
import ComConfirmationUploadDialog from '@/pages/case-import/confirmation-upload/confirmation-batch-upload-loader.js';
import * as filter from '@/assets/js/filter';
import * as session from '@/assets/js/session';
// xss
import VueDOMPurifyHTML from 'vue-dompurify-html';

/**
 * 统计相关-start
 */
import ReportBase from '@com.thunisoft.9law/statistics';
import pkgJson from '../package.json';
// 统一上传SDK
import JiuLawUpload from '@com.thunisoft.9law/uploadSDK';

autoRefresh(router.options.base, () => {
  Vue.prototype.$confirm('检测到页面有内容更新，为了功能的正常使用，请点击立即刷新？', '更新提示', {
    confirmButtonText: '立即刷新',
    cancelButtonText: '忽略',
    showClose: false,
    showCancelButton: false,
    type: 'warning',
    closeOnClickModal: false,
    closeOnPressEscape: false,
    customClass: 'c-message-tip'
  }).then(() => {
    sessionStorage.clear();
    window.location.reload();
  });
});
Vue.use(VueDOMPurifyHTML);

router.beforeEach((to, from, next) => {
  if (window.project_config) {
    routerJumpFunc(to, from, next);
  } else {
    // showErr
    this.$message.error('项目初始化失败，请刷新重试');
  }
});

Vue.prototype.$uploadJS = new JiuLawUpload({
  baseUrl: `${api.BASE_SERVER}`,
  preUrl_: '/api/v1/file/generatePresignedInfo',
  verifyFileUrl: '/api/v1/file/verifyFile',
  classType: 'brtTest'
});

// if (process.env.NODE_ENV === 'development') {
//   require('./mock/index');
// }
console.log('project_config', window, window.project_config);

const isSassChannel = window.project_config ? window.project_config.isSassChannel() : true;
const isMinIo = window.project_config ? window.project_config.getConfig('uploadChannel_minIo') : false;
Vue.prototype.$isMinIo = isMinIo;
const sysChannel = window.project_config ? window.project_config.getSystemChannel() : 'sass';
Vue.prototype.$sysChannel = sysChannel;

// 统计上报
const reportJs = new ReportBase({
  appId: 1,
  sysId: 'tj-1',
  appVersion: pkgJson.version,
  url: (process.env.HOST == 'prod' || process.env.HOST == 'pre') ? 'https://jiulaw.cn/report.png' : '/report.png',
  postUrl: (process.env.HOST == 'prod' || process.env.HOST == 'pre') ? 'https://jiulaw.cn/report' : 'http://172.16.16.230:18080/report',
  usePv: isSassChannel,
  useCust: isSassChannel,
  useJsErr: isSassChannel,
  cn: 'tj-1*', // 内部渠道号,根据业务在home页补全zqsb_1_caseId
  co: '-', // 外部渠道号
  usePerf: isSassChannel,
  usePerf_FPS: isSassChannel,
  useVisual: true,
  visualVersion: 'v1.0.0',
  receiveOrigin: (process.env.HOST == 'prod' || process.env.HOST == 'pre') ? 'https://jiulaw.cn' : 'http://172.16.14.224:18080',
  visualBaseUrl: (process.env.HOST == 'prod' || process.env.HOST == 'pre') ? 'https://jiulaw.cn' : 'http://172.16.14.224:18080',
  Vue,
  router,
  isConsoleLog: !(process.env.HOST == 'prod' || process.env.HOST == 'pre')
});
Vue.prototype.$reportJs = reportJs;
reportJs.setJsErrListener(Vue.config);

const bus = new Vue();
Vue.prototype.$bus = bus;
Vue.config.productionTip = false;
Vue.config.errorHandler = function (err, vm, info) {
  // handle error
  // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
  // 只在 2.2.0+ 可用
  console.error('Vue.config.errorHandler ', err, vm, info);
};
Vue.use(loading);
Vue.use(commonView);
Vue.use(BatchUploadDialog);
Vue.use(ComBatchUploadDialog);
Vue.use(ComConfirmationUploadDialog);
Vue.use(domLoading);
Vue.use(commonTooltip);

Vue.prototype.$utils = utils;
Vue.prototype.$constant = constant;
Vue.prototype.$validConst = validConst;
Vue.prototype.$api = api;
Vue.prototype.$AppCache = AppCache;
Vue.prototype.$session = session;


Object.keys(filter)
  .forEach(key => {
    Vue.filter(key, filter[key]);
  });


function routerJumpFunc(to, from, next) {
  const actId = sessionStorage.getItem(constant.cache_crrentActId) || '';
  const batchId = to.query.batchId || '';
  const mediateId = to.query.mediateId || '';
  Vue.prototype.$reportJs.setCn(`tj-1*${actId}*${batchId}*${mediateId}`);
  const system = from.query.system;
  const style = from.query.style;
  const id = to.query.id ? to.query.id : from.query.id;
  if (system && !to.query.system) {
    to.query.id = id;
    next({
      name: to.name,
      query: {...to.query, system, style},
      params: to.params,
      replace: (to.name === from.name && to.meta && to.meta.replace) || false
    });
  } else if (style && !to.query.style) {
    const query = {
      ...to.query,
      id
    };
    if (!query.style) {
      query.style = style;
    }
    next({
      name: to.name,
      query,
      params: to.params,
      replace: (to.name === from.name && to.meta && to.meta.replace) || false
    });
  } else if (!to.query.id && id) {
    next({
      name: to.name,
      query: {
        ...to.query,
        id
      },
      params: to.params,
      replace: (to.name === from.name && to.meta && to.meta.replace) || false
    });
  } else {
    next();
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  mixins: [reportJs.lifeMixin || {}]
});
